module.exports = __webpack_public_path__ + "static/media/csrd_report5.3d70bcf7.svg";